import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ScissorsIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			fill="currentColor"
			d="m6.005 8.223-.237.818-.879.668a2.078 2.078 0 0 0-2.781-.721 2.166 2.166 0 0 0-.856 2.903 2.08 2.08 0 0 0 2.853.845 2.167 2.167 0 0 0 1.053-2.377L15 4.261a6.155 6.155 0 0 0-5.776 1.22l-3.22 2.742Zm-2.146 2.221a.838.838 0 0 0-1.152-.332.873.873 0 0 0-.353 1.167.838.838 0 0 0 1.152.332.873.873 0 0 0 .353-1.167Z"
		/>
		<path
			d="m8.203 9.65 1.02.868A6.154 6.154 0 0 0 15 11.739l-5.085-3.15L8.203 9.65Z"
			fill="currentColor"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			fill="currentColor"
			d="M6.51 6.479 5.159 5.64a2.167 2.167 0 0 0-1.053-2.377 2.08 2.08 0 0 0-2.853.845 2.166 2.166 0 0 0 .856 2.903c.982.545 2.197.22 2.781-.72l.879.667.035.122.708-.602Zm-3.803-.591a.838.838 0 0 0 1.152-.332.873.873 0 0 0-.353-1.167.838.838 0 0 0-1.152.332.873.873 0 0 0 .353 1.167Z"
		/>
	</svg>
))
